
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as _91slug_930GqRg_45URxZnrbZhQR1HdrptjGhpkIM9RWyzbD3F8irkMeta } from "/app/pages/[slug].vue?macro=true";
import { default as hakkimizdaLhOGLQkU_45luel0oocoaicB_45j8JDWg0yl8_45r56rSf_45ksMeta } from "/app/pages/hakkimizda.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    component: () => import("/app/pages/[slug].vue")
  },
  {
    name: "hakkimizda",
    path: "/hakkimizda",
    component: () => import("/app/pages/hakkimizda.vue")
  }
]